"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
var types_1 = require("@bringg/types");
var TimeService = (function () {
    function TimeService() {
    }
    TimeService.format = function (date, format, hourFormat) {
        if (hourFormat === void 0) { hourFormat = types_1.HourFormat.Default; }
        if (hourFormat === types_1.HourFormat.TwelveHours) {
            return this.formatTwelveHours(date, format);
        }
        if (hourFormat === types_1.HourFormat.TwentyFourHours) {
            return this.formatTwentyFourHours(date, format);
        }
        return this.timezoneSafeMomentFormat(date, format);
    };
    TimeService.formatTwelveHours = function (date, format) {
        var _a;
        var twelveHoursFormat = (_a = this.convertLocalizeFormat(format)) === null || _a === void 0 ? void 0 : _a.replace(/H/g, 'h');
        return this.timezoneSafeMomentFormat(date, twelveHoursFormat);
    };
    TimeService.formatTwentyFourHours = function (date, format) {
        var _a, _b;
        var twentyFourHoursFormat = (_b = (_a = this.convertLocalizeFormat(format)) === null || _a === void 0 ? void 0 : _a.replace(/h/g, 'H')) === null || _b === void 0 ? void 0 : _b.replace(/ A/g, '');
        return this.timezoneSafeMomentFormat(date, twentyFourHoursFormat);
    };
    TimeService.timezoneSafeMomentFormat = function (date, format) {
        return moment_1.default.isMoment(date) ? date.format(format) : (0, moment_1.default)(date).format(format);
    };
    TimeService.convertLocalizeFormat = function (format) {
        var _a;
        return (_a = format === null || format === void 0 ? void 0 : format.replace('LTS', 'H:mm:ss A')) === null || _a === void 0 ? void 0 : _a.replace('LT', 'H:mm A');
    };
    return TimeService;
}());
exports.default = TimeService;
//# sourceMappingURL=time-service.js.map